import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Modal, Typography } from "@material-ui/core";
import { Section } from "@components/organisms";
import { Document, Page, pdfjs } from "react-pdf";
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "scroll",
    // background: theme.palette.primary.dark,
  },
  textWhite: {
    color: "white",
  },
  title: {
    fontWeight: "bold",
  },
  modalBackground: {
    backgroundColor: theme.palette.background.default,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  modalView: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    color: theme.palette.background.header,
  },
}));

const PDFViewer = (props) => {
  const { className, title, subtitle, fileUrl, openModal, setOpenModal, isDownloadable, ...rest } = props;
  const classes = useStyles();

  // const [numPages, setNumPages] = React.useState(null);
  // const [pageNumber, setPageNumber] = React.useState(1);

  const handleClose = () => setOpenModal(false);

  // function onDocumentLoadSuccess({ numPages }) {
  //   setNumPages(numPages);
  // }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Section>
        {title && !isMobile && <h4>{title}</h4>}

        {fileUrl && !isMobile && (
          <div>
            <iframe
              name="files"
              src={isDownloadable ? fileUrl : `${fileUrl}#toolbar=0`}
              title={title}
              style={{ width: "100%", height: `${800}px` }}
            >
              Press me: <a href={fileUrl}>Download PDF</a>
            </iframe>
            {isDownloadable && (
              <Typography>Press me: <a target="_blank" rel="noreferrer" href={fileUrl} download={`${title}.pdf`}>Download PDF</a></Typography>
            )}
            {/* <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
              <Page pageNumber={pageNumber} />
            </Document>
            <p>
              Page {pageNumber} of {numPages}
            </p> */}
          </div>
        )}
        
        {/* {fileUrl && isMobile && (
          <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div>
              <div className={clsx(classes.modalView, classes.modalBackground)}>
                {title && <h4>{title}</h4>}
                <FontAwesomeIcon
                  icon={faTimesCircle}
                  size="2x"
                  className={classes.icon}
                  onClick={() => setOpenModal(false)}
                />
              </div>
              <iframe
                src={fileUrl}
                title={title}
                style={{ width: "100%", height: `${window.innerHeight - 100}px` }}
              >
                Presss me: <a href={fileUrl}>Download PDF</a>
              </iframe>
              <div className={classes.modalBackground}>
                Presss me: <a target="_blank" rel="noreferrer" href={fileUrl} download={`${title}.pdf`}>Download PDF</a>
              </div>
            </div>
          </Modal>
        )} */}
      </Section>
    </div>
  );
};

PDFViewer.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
  /**
   * Title of the document
   */
  title: PropTypes.string,
  /**
   *  Subtitle of the document
   */
  subtitle: PropTypes.string,
  /**
   * File URL of the document
   */
  fileUrl: PropTypes.string.isRequired,
};

export default PDFViewer;